import { Dispatch, Ref, SetStateAction } from 'react'
import './Input.css'
import './ResRegInput.css'
import { useTranslation } from 'react-i18next';
import {ReactComponent as IcError} from '../../../assets/svgs/icon/ic_error.svg'
import { InputInfoMsg } from './Input';
import { palette } from 'common/commonStyle';

interface ResRegInputProps {
    frontRef?: Ref<HTMLInputElement>;
    backRef?: Ref<HTMLInputElement>;
    frontVal: string;
    backVal: string;
    setFrontVal: Dispatch<SetStateAction<string>>;
    setBackVal: Dispatch<SetStateAction<string>>;
    infoMsg?: InputInfoMsg
}


export const ResRegInput = (
    {
        frontVal,
        backVal,
        frontRef,
        backRef,
        setFrontVal,
        setBackVal,
        infoMsg
    } : ResRegInputProps
) => {
    const {t} = useTranslation();

    return (
        <div style={{padding: "10px 0"}}>
            <div className="common-input-title-container">
                <span className="common-input-title">{t("signUp.resRegNum")}</span>
            </div>
            
            <div
                className="common-resreg-input-box"
            >
                <div className="common-resreg-input-front-box">
                    <input
                        className="common-resreg-input-front"
                        type="text"
                        id="resreg_front"
                        ref={frontRef}
                        onChange={(e) => {setFrontVal(e.target.value.replace(/[^0-9]/g, ''))}}
                        maxLength={6}
                        inputMode='numeric'
                        value={frontVal}
                        placeholder="●●●●●●"
                    />
                </div>
                <span>-</span>
                <div className="common-resreg-input-back-box">
                    <input
                        className="common-resreg-input-back"
                        type="text"
                        ref={backRef}
                        id="resreg_back"
                        onChange={(e) => {setBackVal(e.target.value.replace(/[^0-9]/g, ''))}}
                        maxLength={1}
                        inputMode='numeric'
                        value={backVal}
                        placeholder="●"
                    />
                    <span>●●●●●●</span>
                </div>
                
            </div>
            <div className="common-input-msg-wrapper">
                {infoMsg &&
                    <>
                        {infoMsg.type === "error" &&
                            <IcError
                                height="12px"
                                width="12px"
                                color={palette.warning}
                            />
                        }
                        {infoMsg.type === "passed" &&
                            <IcError
                                height="12px"
                                width="12px"
                                color={palette.primary}
                            />
                        }
                        <span className={`common-input-msg ${infoMsg.type}`}>{infoMsg.msg}</span>
                    </>
                }
            </div>
        </div>
    )
}